/**
 * Parst Versandkosten aus verschiedenen Formaten.
 * Unterstützt: "0.00", "5.99", "DE:::0.00 EUR", "free", etc.
 * Gibt undefined zurück wenn nicht parsbar.
 */
export function parseDeliveryCost(
  raw: string | number | null | undefined,
): number | undefined {
  if (raw === undefined || raw === null || raw === "") return undefined;
  if (typeof raw === "number") return isNaN(raw) ? undefined : raw;

  const s = String(raw).trim();

  // "DE:::0.00 EUR", "AT:::5.99 EUR" → Zahl extrahieren
  const match = s.match(/([\d]+[.,]?\d*)/);
  if (match && match[1]) {
    const n = parseFloat(match[1].replace(",", "."));
    if (!isNaN(n)) return n;
  }

  return undefined;
}
